module.exports = __webpack_public_path__ + "img/微信视频号.53d37001.png";